(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('AnomalyCategory', AnomalyCategory);

    AnomalyCategory.$inject = ['$resource'];

    function AnomalyCategory ($resource) {
        var resourceUrl =  'api/anomaly-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
